import axios from '@/libs/api.request'
// 导师端timesheet接口
const menteeService = {
  // 任务数量
  taskNums (data) {
    return axios.request({
      url: '/ugd/appointment/backlog',
      data,
      method: 'POST'
    })
  },
  // mentee列表
  menteeList (data) {
    return axios.request({
      url: '/ugd/joint/mentees',
      data,
      method: 'POST'
    })
  },
  // 获取学员详情-基本信息
  menteeDetail (data) {
    return axios.request({
      url: '/ugd/mentee/detail',
      data,
      method: 'POST'
    })
  }
}

export default menteeService
